<template>        
  <div>
    <validationCode :valorCode = validateProps />
  </div> 
</template>
  
  <script>
  import validationCode from './components/form_validation_code_components.vue';
  
  export default {
    name: 'PasswordValidation',
    components: {
      validationCode,
    },

    props: {
      validateProps: {
        required: true
      },
    },

    data() {
    return {
    };
  },

  }
  </script>
  
  <style lang="css" scoped>
  
  </style>

  